
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IDataGridPageRequest } from 'shared';
import { map } from 'rxjs/operators';
import {
  CORE_FUNCTIONS,
  IServerResponse,
} from '@app/core';
import { environment } from 'src/environments/environment';

@Injectable()
export class DatosService {
  private url: string = `${environment.baseUrlAPIDWH}/serviciotuni`;
  private urlPortalTuniDWH = `${environment.baseUrlAPIDWH}`;

  constructor(private http: HttpClient) {}

  listarBaseDatos = (pageRequest: IDataGridPageRequest, filters: any) => {
    return this.http.post<IServerResponse<any[]>>(`${this.url}/listar`, {
      ...pageRequest,
      orderBy: 'asc',
      ...filters,
    });
  };

  descargarZip = (id_archivo: number[]) => {
    const data = {
      archivos: id_archivo,
    };
    return this.http.post<IServerResponse<any>>(`${this.url}`, data);
  };

  getCantidadUniversidadesDWH = (periodo: string, tipo: string) => {
    return this.http
      .post<IServerResponse<number>>(
        `${this.urlPortalTuniDWH}/entidad/cantidad`,
        { periodo, tipo }
      )
      .pipe(map((r) => CORE_FUNCTIONS.numberSpaces(r.data)));
  };

  getFechaCorte = (modulo: string = '') => {
  
    return this.http
      .post<IServerResponse<number>>(
        `${this.urlPortalTuniDWH}/entidad/FechaCorte?modulo=${modulo}`,
        {}
      )
      .pipe(map((r) => CORE_FUNCTIONS.numberSpaces(r.data)));
  };
}
